import { observable, runInAction } from 'mobx';
import { IReportWAndCServices, SSXLKN3MModel, THXLKN3MModel } from 'services/Main/reportWAndC_service';
import { DataResponse } from 'services/response';

export type ReportWAndCStore = {
    //Báo cáo Tổng hợp XLKN 3 miền
    reportTHXLKN3M: DataResponse<Array<THXLKN3MModel>>
    //Báo cáo so sánh XLKN 3 miền
    reportSSXLKN3M: DataResponse<Array<SSXLKN3MModel>>
};

export interface IReportWAndCPresenter {
    createStore(): ReportWAndCStore;
    // Hàm lấy data báo cáo tổng hợp xlkn 3 miền
    getDataTHXLKN3M(store: ReportWAndCStore, data: object): Promise<void>
    // Xuất Excel báo cáo tổng hợp xlkn 3 miền
    exportExportReportTHXLKN3M(dataSearch: Object): Promise<void>

    // Hàm lấy data báo cáo so sánh xlkn 3 miền
    getDataSSXLKN3M(store: ReportWAndCStore, data: object): Promise<void>
    // Xuất Excel báo cáo so sánh xlkn 3 miền
    exportExportReportSSXLKN3M(dataSearch: Object): Promise<void>
}

export function createReportWCPresenter({ reportWCServices }: { reportWCServices: IReportWAndCServices }): IReportWAndCPresenter {
    return {
        createStore: (): ReportWAndCStore =>
            observable({
                //Báo cáo Tổng hợp XLKN 3 miền
                reportTHXLKN3M: {
                    data: [],
                    message: '',
                    isSuccess: false,
                    paging: {
                        totalCount: 0,
                        pageIndex: 0,
                        pageSize: 0,
                        totalPages: 0
                    }
                },
                //Báo cáo so sánh XLKN 3 miền
                reportSSXLKN3M: {
                    data: [],
                    message: '',
                    isSuccess: false,
                    paging: {
                        totalCount: 0,
                        pageIndex: 0,
                        pageSize: 0,
                        totalPages: 0
                    }
                }
            }),
        // // Hàm lấy data báo cáo tổng hợp xlkn 3 miền
        getDataTHXLKN3M: async (store, dataSearch) => {
            try {
                const result = await reportWCServices.getDataReportTHXLKN3M(dataSearch);
                runInAction(() => {
                    store.reportTHXLKN3M.data = result.data;
                    store.reportTHXLKN3M.isSuccess = result.isSuccess;
                    store.reportTHXLKN3M.message = result.message;
                    store.reportTHXLKN3M.paging = result.paging;
                });
            } catch (error) {
                console.log(error);
            }
        },
        // Xuất Excel báo cáo tổng hợp xlkn 3 miền
        exportExportReportTHXLKN3M: async (dataSearch) => {
            try {
                await reportWCServices.exportExportReportTHXLKN3M(dataSearch);

            } catch (error) {
                console.log(error);
            }
        },
        // // Hàm lấy data báo cáo so sanh xlkn 3 miền
        getDataSSXLKN3M: async (store, dataSearch) => {
            try {
                const result = await reportWCServices.getDataReportSSXLKN3M(dataSearch);
                runInAction(() => {
                    store.reportSSXLKN3M.data = result.data;
                    store.reportSSXLKN3M.isSuccess = result.isSuccess;
                    store.reportSSXLKN3M.message = result.message;
                    store.reportSSXLKN3M.paging = result.paging;
                });
            } catch (error) {
                console.log(error);
            }
        },
        // Xuất Excel báo cáo so sánh xlkn 3 miền
        exportExportReportSSXLKN3M: async (dataSearch) => {
            try {
                await reportWCServices.exportExportReportSSXLKN3M(dataSearch);

            } catch (error) {
                console.log(error);
            }
        }

    };
}
